<template>
  <div>
    <div class="banner">
      <div class="banner-img">
        <div class="banner-content" style="position:relative">
          <div style="width:560px">
            <p class="p20"><span class="span-line"></span>BLOCK CHAIN</p>
            <p class="p50">基于版权区块链的存证</p>
<!--            <p class="p25">数据直通互联网法院</p>-->
<!--            <p class="p25">司法认可的版权区块链存证</p>-->
            <p  class="p25" style="width: 660px;font-size: 20px;">作品信息上传至区块链，获得精准授时，信息永久不可篡改。版权所有者日后进行版权授权交易及维权时，区块链存证证书都将成为有效的证据。</p>
            <button @click="gocunzheng()" class="btn138">去存证</button>
          </div>
          <!-- <img src="./images/banner.png" class="position-img" /> -->
        </div>
      </div>
    </div>
    <div class="cert-center">
      <div class="cert-center-top">
        <span></span>
        <span>区块链怎么解决传统确权方式</span>
      </div>
      <div class="cert-center-one">
        <div class="common-box" style="left:-46px">
          <img src="./images/icon1.png" />
          <span>填写复杂表格</span>
        </div>
        <div class="common-box common-box-right" style="right:-41px">
          <span>快速、简便</span>
          <img src="./images/icon7.png" />
        </div>
      </div>
      <div class="cert-center-one" style="height:201px;margin:31px 0px 4px;">
        <div class="common-box" style="left:-146px;top:62px">
          <img src="./images/icon2.png" />
          <span>过程繁琐</span>
        </div>
        <div class="common-box-img" style="left:109px;">
          <img src="./images/icon4.png" />
          <p>传统的版权存证方式</p>
        </div>
        <div class="common-box-yellow" style="top:26px">
          <img src="./images/icon5.png" />
        </div>
        <div class="common-box-img common-box-img2">
          <img src="./images/icon6.png" />
          <p style="color: #000;">版权家区块链存证</p>
        </div>
        <div class="common-box common-box-right" style="right:-145px;top:62px">
          <span>没有繁琐过程</span>
          <img src="./images/icon8.png" />
        </div>
      </div>
      <div class="cert-center-one">
        <div class="common-box" style="left:-66px">
          <img src="./images/icon3.png" />
          <span>耗时耗力</span>
        </div>
        <div class="common-box common-box-right" style="right:-13px">
          <span>存在性证明</span>
          <img src="./images/icon9.png" />
        </div>
      </div>
      <div class="cert-center-bottom">
        <!--        <p>版权家和中国版权保护中心合作推出了DCI版权电子证书</p>-->
        <!--        <p style="margin:10px 0px 25px">存证后可免费在版权家获取版权作品电子证书</p>-->
        <button @click="gocunzheng()">去存证</button>
      </div>
    </div>
    <div class="cert-bottom">
      <div class="cert-bootm-content">
        <div class="cert-bootm-content-left">
          <span style="left:114px">存在性证明</span>
          <span style="left:168px;top:82px">授权证据固定</span>
          <span style="left:-64px;top:145px;">属权身份证明</span>
          <span style="right:-69px;top:140px">授权交易证明</span>
        </div>
        <div style="width: 700px;margin-right: 0" class="cert-bootm-content-right">
          <p class="p-25">版权家接入区块链-天平链</p>
          <img src="./images/qukuailian.png" />
          <p class="p-14">“天平链”首例案件宣判 安妮股份版权区块链证据获认可</p>
          <p class="p-14">2019年4月9日，北京互联网法院首例采纳“天平链”电子证据宣判的侵害作品信息网络传播权纠纷案下达一审判决。安妮股份旗下北京版全家科技发展有限公司（简称“版权家”）作为本案中的第三方区块链存证平台，为本案提供了重要电子证据。 </p>
          <p  class="p-14">北京互联网法院于2018年9月9日正式揭牌。为提高电子数据的证据效力，将司法与科技进一步结合，其开创性的与国内多家领先区块链产业企业共建区块链电子证据平台—“天平链”，此次案件是北京互联网法院使用“天平链”电子证据作为证据宣判的第一起案件。</p>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
  export default {
    metaInfo: {
      title: '存证介绍|时尚知识产权保护平台',
      meta: [{                 // set meta
        name: 'keyWords',
        content: ''
      },{
        name: 'Description',
        content: ''
      }]
    },
    name: "copyrightEvidence",
    methods:{
      gocunzheng(){
        let query = {
              code:1001
          };
        this.$router.push({ path:'/apply-cert',query: query })
      }
    }
  };
</script>
<style scoped lang="less">
  .banner{
    width: 100%;
    height:460px;
    background: #121210;
    margin-bottom: 100px;
    .banner-img{
      width: 100%;
      height:460px;
      .banner-content{
        width:1334px;
        height: 450px;
        margin:0 auto;
        background: url(./images/wangge.png) no-repeat;
        background-size: 100% 100%;
        background-position: center;
        .p20{
          font-size:20px;
          font-weight:300;
          color:rgba(255,255,255,1);
          line-height:28px;
          letter-spacing:2px;
          padding: 58px 0px 10px;
          .span-line{
            display: inline-block;
            width:70px;
            height:1px;
            background: #fff;
            vertical-align: middle;
            margin-right: 15px;
          }
        }
        .p50{
          font-size:50px;
          font-weight:bold;
          color:rgba(255,255,255,1);
          line-height:70px;
          letter-spacing:6px;
          margin-bottom: 25px;
        }
        .p25{
          font-size:25px;
          font-weight:400;
          color:rgba(255,255,255,1);
          line-height:34px;
          letter-spacing:10px;
        }
        .btn138{
          width:138px;
          height:42px;
          background:rgba(255,255,255,1);
          line-height: 42px;
          border:0;
          font-size:14px;
          font-weight:400;
          color:rgba(25,25,25,1);
          outline: none;
          margin-top:40px;
          cursor: pointer;
        }
      }
      .position-img{
        position: absolute;
        width:800px;
        height: auto;
        top:0px;
        left:569px;
      }
    }
  }
  .cert-center{
    width:1023px;
    height: 878px;
    margin:0 auto;
    background:url(./images/icon10.png) no-repeat;
    background-size: cover;
    margin-bottom: 100px;
    .cert-center-top{
      width:632px;
      height:46px;
      font-size:46px;
      font-weight:500;
      color:rgba(24,24,24,1);
      letter-spacing:2px;
      margin:0 auto;
      position: relative;
      padding-top: 49px;
      padding-bottom: 177px;
      span{
        display: inline-block;
        position: absolute;
      }
      span:first-child{
        width:55px;
        height:55px;
        border-radius: 100%;
        left:185px;
        top:48px;
      }
    }
    .cert-center-one{
      height: 70px;
      width:1023px;
      position: relative;
      div{
        float: left;
        position: absolute;
      }
    }
  }
  .common-box{
    width:194px;
    height:70px;
    background:rgba(255,255,255,1);
    box-shadow:-8px 10px 45px 0px rgba(121,128,178,0.08);
    border-radius:36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size:14px;
    font-weight:400;
    color:rgba(102,102,102,1);
    overflow: hidden;
    img{
      width:54px;
      height: 54px;
      margin:8px;
    }
    span{
      margin-right: 33px;
    }
  }
  .common-box-img{
    width:328px;
    height:201px;
    font-size:14px;
    font-weight:400;
    color:rgba(102,102,102,1);
    overflow: hidden;
    background:url(./images/icon11.png) no-repeat;
    background-size:cover;
    img{
      width: 23px;
      height: 30px;
      margin:60px 181px 10px 124px;
    }
    p{
      margin-left: 70px;
    }
  }
  .common-box-img2{
    background:url(./images/icon12.png) no-repeat;
    background-size: cover;
    right:110px;
    img{
      width: 33px;
      height: 29px;
      margin:60px 181px 10px 177px;
    }
    p{
      margin-left: 137px;
    }
  }
  .common-box-yellow{
    width:148px;
    height: 148px;
    background:#E82E31;
    border-radius: 100%;
    left:437px;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width:55px;
      height:59px;
    }
  }
  .common-box-right{
    img{
      width:54px;
      height: 54px;
      margin:0px;
      margin-right:11px;
    }
    span{
      margin-right: 0px;
      margin-left: 37px;
    }
  }
  .cert-center-bottom{
    text-align: center;
    margin-top: 139px;
    p{
      font-size:16px;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:22px;
    }
    button{
      width:138px;
      height:40px;
      border:0;
      outline: none;
      background:rgba(18,18,16,1);
      border-radius:2px;
      font-size:14px;
      font-weight:400;
      color:#fff;
      line-height:40px;
      cursor: pointer;
    }
  }
  .cert-bottom{
    width:100%;
    height:334px;
    background:rgba(72,97,214,1);
    .cert-bootm-content{
      width: 1334px;
      margin:0 auto;
      height:334px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .cert-bootm-content-left{
        width:283px;
        height: 269px;
        background:url(./images/tpliang.png) no-repeat;
        background-size: cover;
        position: relative;
        margin-left: 96px;
        span{
          position: absolute;
          font-size:14px;
          font-weight:400;
          color:#fff;
          line-height:20px;
        }
      }
      .cert-bootm-content-right{
        margin-right: 155px;
        .p-25{
          font-size:25px;
          color:rgba(255,255,255,1);
          line-height:34px;
          letter-spacing:3px;
        }
        img{
          width:200px;
          height: 45px;
          margin:25px 0px 20px;
        }
        .p-14{
          font-size:14px;
          font-weight:400;
          color:rgba(255,255,255,0.6);
          line-height:20px;
          letter-spacing:2px;
          margin-bottom:5px;
        }
      }
    }
  }
</style>